import React from 'react';
import Footer from '../component/Footer';
import 'bootstrap/dist/css/bootstrap.min.css'; // Ensure Bootstrap is included

const PediatricUrology = () => {
  return (
    <>
      <div className="container my-5">
        <h1 className="text-center mb-4">Pediatric Urology Care</h1>

        <section className="mb-4">
          <h2>Kidney Stone Removal by Laser in Children</h2>
          <p className="text-justify">
            Kidney stones can cause significant discomfort and pain in children.  Dr. Manish Khattar offers laser kidney stone
            removal using state-of-the-art laser lithotripsy. This advanced technology breaks down kidney stones without the
            need for invasive surgery, ensuring minimal pain and faster recovery. Laser treatment is highly effective and safe,
            making it an ideal option for young patients.
          </p>
        </section>

        <section className="mb-4">
          <h2>Treatment for Posterior Urethral Valve (PUV)</h2>
          <p className="text-justify">
            Posterior Urethral Valve (PUV) is a congenital condition in boys that can obstruct urine flow, affecting bladder
            and kidney function.  Dr. Manish Khattar specializes in treating PUV by utilizing advanced diagnostic tools such as urodynamic
            studies to accurately assess the condition. He then offers precise surgical interventions to relieve the obstruction,
            helping restore normal urinary function and prevent further complications.
          </p>
        </section>

        <section className="mb-4">
          <h2>Managing Blood in Urine (Hematuria) in Children</h2>
          <p className="text-justify">
            The presence of blood in a child’s urine can be alarming and may indicate an underlying urological condition. Dr.
             Manish Khattar provides a comprehensive diagnostic approach to determine the cause of hematuria, which could range from
            infections or injuries to more severe conditions like kidney disease. Based on the diagnosis,  Dr. Manish Khattar offers effective
            treatments to resolve the issue and safeguard your child’s health.
          </p>
        </section>

        <section className="mb-4">
          <h2>PUJ Obstruction Treatment</h2>
          <p className="text-justify">
            PUJ obstruction refers to a blockage at the junction where the kidney meets the ureter.  Dr. Manish Khattar uses minimally
            invasive surgical techniques to treat PUJ obstruction, helping restore normal kidney function and ensuring a smooth recovery.
            By addressing this issue early,  Dr. Manish Khattar minimizes the risk of long-term complications and provides your child with the best
            chance for a full recovery.
          </p>
        </section>

        <section className="mb-4">
          <h2>Undescended Testis (Cryptorchidism) Treatment</h2>
          <p className="text-justify">
            Undescended testis, or cryptorchidism, is a common condition in male infants. Dr. Manish Khattar offers surgical correction to reposition
            the testis into its proper place, reducing the risk of future complications like infertility or testicular cancer. His expertise
            ensures that the procedure is safe and effective, providing long-term benefits for your child’s health.
          </p>
        </section>

        <section className="mb-4">
          <h2>Phimosis Treatment</h2>
          <p className="text-justify">
            For children diagnosed with phimosis, where the foreskin cannot be fully retracted,  Dr. Manish Khattar provides both medical and
            surgical treatment options. His approach is tailored to the specific needs of the patient, ensuring that your child receives the
            most appropriate care for this condition and experiences relief from discomfort.
          </p>
        </section>
      </div>
      
      <Footer />
    </>
  );
};

export default PediatricUrology;
